import { Injectable } from '@angular/core';
import { Punto } from '../entidades/Punto';


@Injectable()
export class ContenidoService {
    private markers: Punto[] = [
        {
            nombre: 'León',
            latitud: 21.121705,
            longitud: -101.654837,
            descripcion: '',
            imagenURL: 'assets/images/marker.png'
        },
        {
            nombre: 'Queretaro',
            latitud: 20.589332,
            longitud: -100.389858,
            descripcion: '',
            imagenURL: 'assets/images/marker.png'
        }
    ];

    private puntoCentral: Punto = {
        nombre: 'Inicial',
        latitud: 20.750352,
        longitud: -100.991981,
        descripcion: '',
        imagenURL: ''
    };

    constructor() {}

    getMarcadores() {
        return this.markers;
    }

    getPuntoCentral() {
        return this.puntoCentral;
    }


}



// WEBPACK FOOTER //
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/servicios/contenido.service.ts